import styled from 'styled-components';

import Btn from 'components/Button';

export const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  margin-bottom: 20px;
  & > div:first-child {
    width: auto;
  }
`;

export const Button = styled(Btn)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: auto;
  border-radius: var(--border-radius8);
  font-size: var(--font-size13);
  font-weight: 500;
  letter-spacing: 0.92px;
  color: var(--color-grey6A);
  padding: 0 15px;
`;
